var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 6418 \xE2\x80\x93 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 5965",
    d: "M6.333 1.5V17.5M11.667 1.5V17.5M1 2.389C1 2.15322 1.09366 1.9271 1.26038 1.76038C1.4271 1.59366 1.65322 1.5 1.889 1.5H16.111C16.3468 1.5 16.5729 1.59366 16.7396 1.76038C16.9063 1.9271 17 2.15322 17 2.389V16.611C17 16.8468 16.9063 17.0729 16.7396 17.2396C16.5729 17.4063 16.3468 17.5 16.111 17.5H1.889C1.65322 17.5 1.4271 17.4063 1.26038 17.2396C1.09366 17.0729 1 16.8468 1 16.611V2.389Z",
    stroke: "#5557C9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnIcon);
export default __webpack_public_path__ + "static/media/Column-icon.45cae96a9e89ea9305478ad168957411.svg";
export { ForwardRef as ReactComponent };